import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

// An API error detail is often an object ({code, message}) or a 422 array.
// Passed to a toast it made React throw ("Objects are not valid as a React
// child") and, with nothing to catch it, blanked the screen.  Every toast
// call in the app shares this object, so coercing here covers them all.
function toText(m) {
  if (m == null || typeof m === "string" || typeof m === "number" || typeof m === "function") return m
  if (typeof m === "object" && m.$$typeof) return m          // a React element is fine
  if (Array.isArray(m)) return m.map((x) => toText(x?.msg ?? x)).join("; ")
  if (typeof m === "object") return m.message || m.detail || m.msg || m.error || JSON.stringify(m)
  return String(m)
}
for (const kind of ["error", "success", "info", "warning", "message"]) {
  const orig = toast[kind]
  if (typeof orig === "function" && !orig.__coerced) {
    const wrapped = (msg, opts) => orig(toText(msg), opts)
    wrapped.__coerced = true
    toast[kind] = wrapped
  }
}

export { Toaster, toast }
